var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 94,
    viewBox: "0 0 235 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M233.295 61.7978C168.17 117.598 82.0937 88.6864 70.715 43.3948C59.3364 -1.89689 111.239 -11.1866 122.594 18.5384C140.985 66.6842 50.3581 98.6541 1 3.14478",
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotted);
export default __webpack_public_path__ + "static/media/dotted.3009f4775901bcbd647137c6a5334170.svg";
export { ForwardRef as ReactComponent };